import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useRef } from 'react';
import { getServiceColor, getServiceIcon, getServiceTypeLabel } from '../../../data/gisServices';
import { ClusterGroup } from './ClusterGroup';

const createServiceIcon = (service, isSelected, kidMode) => {
  const color = getServiceColor(service.category);
  const emoji = getServiceIcon(service.type);

  return L.divIcon({
    html: `
      <div class="gis-service-shell ${isSelected ? 'gis-service-shell-selected' : ''}">
        <div class="gis-service-marker ${isSelected ? 'gis-service-marker-selected' : ''} ${kidMode ? 'gis-service-marker-kid' : ''}" style="background:${color};">
          ${emoji}
        </div>
        ${kidMode ? '<span class="gis-service-spark">💫</span>' : ''}
      </div>
    `,
    className: 'gis-service-marker-wrapper',
    iconSize: [50, 50],
    iconAnchor: [25, 25]
  });
};

export const GISLayer = ({ services = [], onServiceSelect, selectedServiceId, autoOpenServiceId, kidMode = true }) => {
  const markerRefs = useRef({});

  useEffect(() => {
    if (!autoOpenServiceId) return;
    const marker = markerRefs.current[autoOpenServiceId];
    if (marker && marker.openPopup) {
      marker.openPopup();
    }
  }, [autoOpenServiceId]);

  return (
    <ClusterGroup
      chunkedLoading
      showCoverageOnHover={false}
      spiderfyOnMaxZoom
      maxClusterRadius={44}
    >
      {services.map((service) => (
        <Marker
          key={service.id}
          ref={(node) => {
            if (node) {
              markerRefs.current[service.id] = node;
            }
          }}
          position={[service.lat, service.lng]}
          icon={createServiceIcon(service, service.id === selectedServiceId, kidMode)}
          eventHandlers={{
            click: () => onServiceSelect?.(service)
          }}
        >
          <Popup className="custom-popup kids-popup kids-popup-service" maxWidth={320}>
            <div dir="rtl" className="kids-popup-body space-y-3">
              <div className="flex justify-between items-center gap-2">
                <h3 className="kids-popup-title">
                  <span>{getServiceIcon(service.type)}</span>
                  {service.name}
                </h3>
                <span className="text-xs font-semibold text-gray-500">
                  {getServiceTypeLabel(service.type)}
                </span>
              </div>
              <p className="text-sm text-gray-700">{service.description}</p>
              <a
                href={service.url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex text-xs font-semibold text-sky-700 underline"
              >
                افتح الرابط
              </a>
            </div>
          </Popup>
        </Marker>
      ))}
    </ClusterGroup>
  );
};
